var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 464,
    viewBox: "0 0 486 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M159.016 370.12C159.016 370.12 220.85 396.157 285.11 366.004C349.37 335.851 385.058 269.613 415.451 216.679C445.846 163.745 433.934 106.927 388.188 78.2202C342.442 49.5134 307.834 84.744 241.263 81.9526C174.692 79.1612 157.405 68.7722 99.9478 101.093C42.4919 133.413 27.0624 218.098 66.5217 284.29C105.982 350.483 159.016 370.12 159.016 370.12Z",
    fill: "#B9ADC8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M159.016 370.12C159.016 370.12 220.85 396.157 285.11 366.004C349.37 335.851 385.058 269.613 415.451 216.679C445.846 163.745 433.934 106.927 388.188 78.2202C342.442 49.5134 307.834 84.744 241.263 81.9526C174.692 79.1612 157.405 68.7722 99.9478 101.093C42.4919 133.413 27.0624 218.098 66.5217 284.29C105.982 350.483 159.016 370.12 159.016 370.12Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.944 127.267C87.5004 145.001 78.0526 166.633 75.6031 190.222L57.3198 187.698C60.2553 160.786 71.1805 136.148 87.7726 115.964L101.944 127.267Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.654 331.009C243.759 338.415 224.027 342.535 203.285 342.535C165.931 342.535 131.843 329.218 105.939 307.262L118.177 294.084C140.824 313.257 170.636 324.903 203.285 324.903C221.423 324.903 238.676 321.312 254.315 314.834L261.654 331.009Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.285 202.407V62.2791C163.21 62.2791 126.896 77.6189 100.409 102.471L112.986 115.388L118.284 120.836L127.547 130.357L193.76 198.389L197.667 202.407L198.182 202.936L199.941 204.736L200.544 205.358L201.477 206.314L202.945 207.827L200.457 208.523L160.08 295.801C149.903 291.514 140.572 285.751 132.368 278.791L196.617 209.59L190.591 211.269H190.581L102.255 235.899L89.1723 239.546L81.6976 241.624L63.9586 246.571C72.1817 270.235 86.8395 291.096 105.939 307.262L118.177 294.084C140.824 313.257 170.636 324.903 203.285 324.903C221.423 324.903 238.676 321.312 254.315 314.834L251.214 308.013L245.81 296.089C236.129 300.107 225.699 302.789 214.774 303.902L203.285 202.407ZM203.285 202.407L191.796 100.912C172.618 102.86 154.957 109.663 140.183 120.001L203.285 202.407Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.922 132.037C101.993 139.34 96.9677 147.349 93.002 155.905C87.9087 166.902 84.565 178.808 83.3111 191.29L75.6031 190.222C78.0526 166.633 87.5004 145.001 101.944 127.267L107.922 132.037Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M196.617 209.59L198.785 207.251L200.252 205.674L200.544 205.358L203.285 202.407H197.667H196.151H163.734H96.365",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.757 202.407H74.981H45.821",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105.939 307.262L89.561 324.903",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.177 294.084L123.338 288.526L132.368 278.791",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M331.589 202.407C331.589 252.742 299.785 295.996 254.315 314.834L251.214 308.013C259.467 304.598 267.243 300.32 274.416 295.309C291.377 283.459 304.966 267.469 313.568 248.909C320.149 234.692 323.813 218.953 323.813 202.407C323.813 198.231 323.58 194.101 323.123 190.037C320.819 169.407 312.791 150.402 300.592 134.496C294.235 126.2 286.741 118.757 278.323 112.363L283.174 106.545C312.674 128.993 331.589 163.589 331.589 202.407Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M278.323 112.363L269.848 122.525C262.742 117.115 254.908 112.558 246.49 109.013L251.992 97.1162C261.479 101.125 270.314 106.266 278.323 112.363Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M283.174 106.545L309.233 75.271H338.393",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M269.848 122.525L203.285 202.407",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M193.955 119.981L191.796 100.912C172.619 102.861 154.957 109.663 140.183 120.001L152.037 135.482C164.04 127.091 178.381 121.57 193.955 119.981Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M212.958 287.859L214.774 303.902C225.699 302.788 236.129 300.106 245.81 296.088L238.987 281.056C230.889 284.535 222.137 286.871 212.958 287.859Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M214.774 303.902C211.003 304.292 207.163 304.487 203.285 304.487C187.908 304.487 173.289 301.387 160.08 295.801L200.456 208.523L196.617 209.59L132.368 278.791C126.653 273.965 121.481 268.546 116.971 262.653C110.751 254.561 105.764 245.559 102.255 235.899C99.6406 228.725 97.8522 221.18 96.9774 213.376C96.5691 209.775 96.365 206.11 96.365 202.407C96.365 199.289 96.5108 196.199 96.8121 193.155C97.8619 181.852 100.856 171.087 105.463 161.157C108.904 153.715 113.249 146.746 118.371 140.37C121.2 136.844 124.271 133.494 127.547 130.357C131.464 126.599 135.692 123.128 140.183 120.001L203.285 202.407L214.774 303.902Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M254.801 91.047L251.992 97.1161",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M246.49 109.013L203.285 202.407",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.58 81.3773L190.328 87.994L191.796 100.912",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M203.285 202.407L86.645 153.223",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9774 213.376L83.4472 214.777C82.9904 210.713 82.7571 206.583 82.7571 202.407H96.3651C96.3651 206.11 96.5692 209.775 96.9774 213.376Z",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4472 214.777L76.5168 215.492",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.285 202.407L100.351 274.256",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M151.769 313.767L154.578 307.698L160.08 295.801",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M200.457 208.523L200.904 207.548L201.36 206.564L201.477 206.314L203.285 202.407",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M217.983 339.858L216.242 316.82L214.774 303.902",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M278.537 300.682L274.416 295.309L266.387 284.813",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.285 202.407L319.925 251.591",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M203.285 202.407L330.056 189.321",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M306.22 130.561L300.592 134.496",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M289.599 142.161L203.285 202.407",
    stroke: "#808080",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M203.283 125.359C191.348 135.983 160.795 146.706 125.174 169.457C125.174 169.457 127.4 246.339 203.283 288.362V125.359Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M203.283 125.359C215.219 135.983 245.771 146.706 281.392 169.457C281.392 169.457 279.166 246.339 203.283 288.362V125.359Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M203.283 131.904C188.875 141.452 163.911 150.55 130.903 171.634C130.903 171.634 132.965 242.877 203.283 281.819C273.602 242.877 275.663 171.634 275.663 171.634C242.655 150.55 217.802 141.452 203.283 131.904Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M275.663 171.633C242.655 150.55 217.802 141.452 203.283 131.903V281.817C273.602 242.876 275.663 171.633 275.663 171.633Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M230.701 203.738H176.758C174.283 203.738 172.275 201.861 172.275 199.548V175.798C172.275 159.586 186.386 146.398 203.73 146.398C221.075 146.398 235.185 159.587 235.185 175.798V199.548C235.184 201.861 233.178 203.738 230.701 203.738ZM181.241 195.357H226.219V175.798C226.219 164.206 216.131 154.777 203.73 154.777C191.329 154.777 181.241 164.206 181.241 175.798V195.357Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M237.624 192.291H168.944V246.532H237.624V192.291Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M210.425 214.815C210.425 210.956 207.078 207.827 202.948 207.827C198.818 207.827 195.47 210.956 195.47 214.815C195.47 217.474 197.058 219.785 199.396 220.967L198.14 233.286H207.753L206.498 220.967C208.836 219.785 210.425 217.474 210.425 214.815Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 86.7226H392.488V75.271H381.161L380.011 72.475H372.974V86.7226Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 105.231H392.488V93.7791H381.161L380.011 90.983H372.974V105.231Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 123.739H392.488V112.287H381.161L380.011 109.49H372.974V123.739Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 239.843H392.488V228.391H381.161L380.011 225.595H372.974V239.843Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 258.351H392.488V246.899H381.161L380.011 244.103H372.974V258.351Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 276.859H392.488V265.407H381.161L380.011 262.611H372.974V276.859Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 296.451H392.488V284.999H381.161L380.011 282.203H372.974V296.451Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 314.959H392.488V303.507H381.161L380.011 300.711H372.974V314.959Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M372.974 333.467H392.488V322.015H381.161L380.011 319.219H372.974V333.467Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M343.982 178.661C343.816 176.811 343.822 174.948 343.94 173.095",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M350.313 178.186C350.171 176.621 350.179 175.046 350.279 173.48",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M343.855 175.88L350.205 175.833",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M343.991 172.37C344.158 170.519 344.456 168.68 344.884 166.866",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M350.319 172.867C350.461 171.303 350.713 169.75 351.073 168.219",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M344.339 169.604L350.614 170.53",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M345.065 166.16C345.539 164.359 346.124 162.58 346.874 160.864",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M351.226 167.623C351.628 166.103 352.118 164.6 352.752 163.154",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M345.867 163.48L351.903 165.361",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M347.166 160.192C347.926 158.48 348.845 156.837 349.849 155.248",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M352.999 162.587C353.638 161.141 354.419 159.754 355.266 158.41",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M348.416 157.675L354.055 160.461",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M350.252 154.633C350.77 153.848 351.32 153.082 351.909 152.345L353.737 150.176",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M355.607 157.889C356.045 157.225 356.512 156.574 357.013 155.952L358.562 154.118",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M351.909 152.344L357.013 155.951",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M354.216 149.611C354.882 148.935 355.575 148.282 356.257 147.619C356.604 147.293 356.932 146.949 357.295 146.64L358.417 145.748",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M358.964 153.636L360.692 151.957C360.984 151.682 361.258 151.388 361.565 151.127L362.515 150.379",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M356.257 147.619L360.692 151.957",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M359.003 145.285C359.746 144.684 360.499 144.095 361.326 143.602C362.136 143.087 362.935 142.552 363.758 142.059",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M363.011 149.987C363.636 149.478 364.268 148.977 364.971 148.565C365.656 148.134 366.327 147.678 367.02 147.26",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M361.327 143.602L364.971 148.565",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M364.428 141.712L366.999 140.392C367.884 140.006 368.789 139.662 369.684 139.299",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M367.587 146.971L369.757 145.852L372.026 144.933",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M366.999 140.392L369.757 145.852",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M370.386 139.019C371.288 138.674 372.235 138.445 373.159 138.155L374.553 137.747L375.98 137.459",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M372.618 144.694C373.38 144.399 374.184 144.215 374.963 143.967L376.14 143.616L377.348 143.379",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M373.159 138.155L374.964 143.967",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M376.725 137.311C377.675 137.111 378.628 136.926 379.599 136.853C380.566 136.758 381.531 136.63 382.5 136.569",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M377.98 143.254C378.783 143.083 379.587 142.919 380.411 142.866C381.229 142.789 382.045 142.674 382.864 142.622",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M379.6 136.853L380.411 142.866",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M383.263 136.557L386.18 136.519L389.089 136.74",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M383.507 142.615L385.973 142.578L388.432 142.769",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M386.18 136.519L385.974 142.578",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M389.848 136.801C390.813 136.91 391.767 137.111 392.725 137.266C393.203 137.352 393.684 137.425 394.159 137.525L395.564 137.903",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M389.073 142.817C389.889 142.908 390.692 143.087 391.502 143.214C391.906 143.286 392.313 143.344 392.714 143.427L393.899 143.752",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M392.725 137.265L391.501 143.215",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M396.297 138.1C398.195 138.537 399.965 139.339 401.779 140.006",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M394.516 143.92C396.122 144.274 397.607 144.976 399.144 145.522",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M399.067 138.973L396.854 144.655",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M402.457 140.338L405.05 141.616C405.899 142.066 406.692 142.609 407.513 143.104",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M399.716 145.806L401.908 146.883C402.627 147.263 403.293 147.73 403.99 148.147",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M405.051 141.616L401.908 146.883",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M408.151 143.501C408.989 143.976 409.705 144.612 410.474 145.179C411.214 145.78 412.027 146.301 412.692 146.983",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M404.53 148.481C405.246 148.874 405.842 149.426 406.494 149.904C407.118 150.414 407.819 150.844 408.373 151.428",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M410.474 145.179L406.494 149.904",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M413.234 147.494C413.916 148.155 414.643 148.779 415.284 149.476L417.147 151.622",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M408.83 151.861C409.404 152.422 410.025 152.942 410.564 153.532L412.135 155.345",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M415.284 149.476L410.564 153.531",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M417.632 152.185C418.702 153.735 419.891 155.22 420.746 156.894",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M412.547 155.816C413.436 157.134 414.459 158.373 415.17 159.794",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M419.267 154.494L413.923 157.768",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M421.107 157.535L421.793 158.765L422.36 160.048C422.72 160.911 423.153 161.749 423.445 162.634",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M415.476 160.334L416.06 161.371L416.534 162.458C416.833 163.188 417.211 163.89 417.454 164.64",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M422.36 160.048L416.533 162.458",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M423.672 163.327C423.953 164.215 424.267 165.096 424.514 165.993L425.111 168.72",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M417.642 165.228C417.877 165.98 418.149 166.723 418.359 167.481L418.861 169.787",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M424.515 165.992L418.36 167.481",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M425.266 169.431C425.468 171.276 425.783 173.117 425.735 174.977",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M418.995 170.388C419.15 171.951 419.439 173.505 419.386 175.079",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M425.592 172.198L419.267 172.73",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M425.745 175.705C425.745 176.169 425.771 176.634 425.749 177.097L425.633 178.486C425.532 179.41 425.525 180.344 425.337 181.256",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M419.396 175.694C419.396 176.086 419.424 176.479 419.403 176.87L419.3 178.043C419.21 178.822 419.22 179.614 419.053 180.384",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M425.633 178.485L419.299 178.044",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M425.203 181.972C425.021 182.884 424.883 183.806 424.655 184.708L423.859 187.391",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M418.938 180.989C418.779 181.758 418.671 182.539 418.479 183.299L417.804 185.563",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M424.654 184.708L418.479 183.299",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M423.648 188.09C422.914 189.809 422.318 191.591 421.352 193.21",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M417.631 186.154C416.994 187.598 416.516 189.111 415.687 190.473",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M422.583 190.685L416.727 188.342",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M421.003 193.855L420.332 195.093C420.093 195.495 419.811 195.876 419.552 196.267L417.956 198.597",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M415.392 191.02L414.83 192.067C414.628 192.409 414.385 192.728 414.165 193.059L412.819 195.035",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M419.552 196.268L414.165 193.059",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M417.481 199.165L415.651 201.332C415.038 202.052 414.308 202.674 413.638 203.347",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M412.413 195.512L410.865 197.348C410.35 197.961 409.724 198.477 409.161 199.049",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M415.651 201.332L410.865 197.349",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M413.102 203.864C412.445 204.553 411.656 205.104 410.916 205.707C410.155 206.286 409.445 206.929 408.614 207.418",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M408.71 199.486C408.162 200.075 407.487 200.53 406.864 201.04C406.22 201.526 405.63 202.081 404.923 202.486",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M410.916 205.708L406.864 201.04",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M407.983 207.826C407.164 208.328 406.391 208.903 405.531 209.337L402.961 210.66",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M404.389 202.828C403.696 203.248 403.053 203.745 402.323 204.107L400.153 205.224",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M405.531 209.337L402.323 204.107",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M402.281 210.984C400.487 211.705 398.712 212.474 396.83 212.959",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M399.578 205.498C398.057 206.096 396.564 206.762 394.969 207.163",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M399.589 212.064L397.303 206.408",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M396.102 213.174C395.181 213.482 394.222 213.642 393.271 213.835C392.317 214.008 391.375 214.259 390.402 214.325",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M394.355 207.346C393.579 207.614 392.765 207.74 391.961 207.904C391.153 208.047 390.359 208.274 389.535 208.321",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M393.271 213.835L391.961 207.904",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M389.646 214.407C388.678 214.487 387.715 214.661 386.742 214.656L383.824 214.696",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M388.895 208.387C388.077 208.45 387.264 208.613 386.44 208.601L383.973 208.636",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M386.742 214.656L386.44 208.601",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M383.064 214.674C381.124 214.532 379.18 214.415 377.273 214.017",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M383.331 208.617C381.692 208.487 380.047 208.404 378.44 208.058",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M380.155 214.448L380.873 208.424",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M376.524 213.886C375.558 213.756 374.631 213.46 373.692 213.215C372.762 212.944 371.803 212.752 370.91 212.376",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M377.807 207.949C376.988 207.848 376.21 207.586 375.418 207.38C374.634 207.148 373.82 207.002 373.07 206.674",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M373.693 213.215L375.419 207.381",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M370.202 212.109C369.305 211.752 368.373 211.464 367.506 211.042L364.911 209.765",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M372.472 206.448C371.717 206.143 370.926 205.913 370.196 205.551L368.005 204.472",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M367.506 211.043L370.196 205.551",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M364.239 209.427C362.624 208.396 360.929 207.471 359.427 206.288",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M367.435 204.189C366.078 203.301 364.629 202.537 363.361 201.529",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M361.793 207.911L365.367 202.901",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M358.829 205.839C357.348 204.639 355.892 203.398 354.598 202.007",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M362.853 201.15C361.603 200.131 360.367 199.088 359.278 197.911",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M356.646 203.993L361.009 199.587",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M354.08 201.475C352.822 200.058 351.593 198.611 350.551 197.039",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M358.84 197.463C357.784 196.264 356.739 195.047 355.864 193.717",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M352.236 199.314L357.285 195.637",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M350.13 196.433C349.128 194.841 348.161 193.223 347.397 191.511",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M355.506 193.207C354.665 191.86 353.841 190.498 353.201 189.05",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M348.676 194.015L354.28 191.166",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M347.086 190.848C346.356 189.127 345.692 187.377 345.214 185.576",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M352.935 188.491C352.323 187.036 351.756 185.557 351.354 184.034",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M346.057 188.241L352.068 186.288",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M345.022 184.873C344.575 183.066 344.238 181.234 344.051 179.385",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M351.191 183.44C350.815 181.911 350.528 180.362 350.37 178.798",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M344.441 182.144L350.702 181.132",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M385.104 151.961C390.058 152.012 395.043 153.478 399.358 156.466C407.009 161.764 410.551 170.461 409.361 178.818",
    stroke: "#543C7D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M361.694 167.117C362.451 165.242 363.473 163.429 364.766 161.725C369.668 155.273 377.347 151.881 385.106 151.961",
    stroke: "#E69724",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M389.279 198.87C382.855 199.992 375.978 198.702 370.275 194.752C360.985 188.32 357.753 176.879 361.694 167.117",
    stroke: "#543C7D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M409.362 178.818C408.829 182.556 407.35 186.226 404.867 189.493C400.973 194.619 395.326 197.813 389.279 198.87",
    stroke: "#E69724",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M178.437 316.815H197.951V305.364H186.624L185.473 302.568H178.437V316.815Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M178.437 335.324H197.951V323.872H186.624L185.473 321.076H178.437V335.324Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M178.437 353.832H197.951V342.38H186.624L185.473 339.584H178.437V353.832Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M209.541 316.815H229.055V305.364H217.728L216.577 302.568H209.541V316.815Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M209.541 335.324H229.055V323.872H217.728L216.577 321.076H209.541V335.324Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M209.541 353.832H229.055V342.38H217.728L216.577 339.584H209.541V353.832Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M178.437 83.8875H197.951V72.436H186.624L185.473 69.6399H178.437V83.8875Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M178.437 102.396H197.951V90.944H186.624L185.473 88.1479H178.437V102.396Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M178.437 120.904H197.951V109.452H186.624L185.473 106.656H178.437V120.904Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M209.541 83.8875H229.055V72.436H217.728L216.577 69.6399H209.541V83.8875Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M209.541 102.396H229.055V90.944H217.728L216.577 88.1479H209.541V102.396Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M209.541 120.904H229.055V109.452H217.728L216.577 106.656H209.541V120.904Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M318.88 412.135C348.405 412.135 372.34 408.603 372.34 404.247C372.34 399.891 348.405 396.359 318.88 396.359C289.355 396.359 265.42 399.891 265.42 404.247C265.42 408.603 289.355 412.135 318.88 412.135Z",
    fill: "#543C7D"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M308.951 393.399C308.951 393.399 298.745 399.663 293.156 400.823C287.567 401.983 285.866 403.607 290.483 405.695C295.1 407.783 309.194 408.479 315.756 407.087C322.317 405.695 324.747 407.551 325.476 404.767C326.205 401.983 325.719 398.967 325.233 396.879C324.747 394.791 312.84 391.543 308.951 393.399Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M295.586 268.116C295.586 268.116 296.801 286.213 300.203 300.365C303.605 314.517 305.306 333.542 307.007 343.982C308.708 354.422 309.923 371.591 310.166 379.247C310.409 386.903 310.895 389.223 310.409 389.919C309.923 390.615 308.708 390.847 308.708 391.775C308.708 392.703 308.465 394.791 308.465 394.791C308.465 394.791 310.652 396.647 316.484 398.735C322.316 400.823 326.204 401.983 326.204 401.983C326.204 401.983 328.634 400.127 329.363 395.951C330.092 391.775 327.905 386.903 327.905 384.119C327.905 381.335 334.223 356.974 332.036 346.998C329.849 337.022 325.475 325.653 325.475 319.621C325.475 313.589 327.905 295.724 327.905 295.724C327.905 295.724 334.223 285.748 334.466 278.556C334.709 271.364 334.223 265.796 334.223 265.796C334.223 265.796 305.549 269.74 295.586 268.116Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M300.588 203.516C300.588 203.516 297.034 212.169 297.034 221.5C297.034 230.831 295.612 251.021 294.191 259.843C292.769 268.665 291.703 269.174 294.191 270.531C296.68 271.889 303.965 273.416 314.806 272.737C325.645 272.059 337.197 268.665 337.73 267.139C338.263 265.612 337.908 263.576 337.374 261.54C336.842 259.504 339.329 238.127 333.998 220.313C328.666 202.498 324.935 193.506 322.446 191.131C319.958 188.755 319.958 188.755 319.958 188.755L300.588 203.516Z",
    fill: "#E69724",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M283.883 158.385C283.883 158.385 283.528 164.663 284.416 166.868C285.304 169.074 285.66 171.619 284.772 173.315C283.883 175.011 282.106 177.048 283.35 178.066C284.594 179.084 286.015 179.762 286.015 179.762C286.015 179.762 289.569 185.87 291.346 189.263C293.123 192.656 294.012 193.505 295.789 192.825C297.566 192.147 299.521 190.959 299.521 190.959C299.521 190.959 304.496 196.388 305.207 197.746C305.918 199.103 307.694 200.29 307.694 200.29L319.778 187.735C319.778 187.735 316.757 184.851 315.513 179.931C314.269 175.011 313.914 174.332 315.157 172.126C316.402 169.92 318.889 169.751 317.468 164.322C316.046 158.893 318 157.196 312.848 153.803C307.694 150.41 297.921 149.901 295.078 149.901C292.235 149.901 290.102 150.749 288.68 151.767C287.26 152.787 283.883 158.385 283.883 158.385Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M295.435 145.831C295.435 145.831 282.64 149.733 280.862 151.259C279.085 152.786 283.528 162.118 283.528 162.118L292.413 157.198L288.681 161.44C288.681 161.44 286.726 161.949 293.657 161.609C300.587 161.27 303.964 158.895 303.964 158.895C303.964 158.895 299.521 163.645 299.877 165.003C300.232 166.361 302.72 168.566 303.43 169.584C304.141 170.602 305.207 169.244 305.207 169.244C305.207 169.244 306.273 173.486 306.629 172.468C306.985 171.45 307.34 167.887 307.34 167.887C307.34 167.887 308.938 164.494 311.249 165.343C313.559 166.191 314.803 171.62 313.204 174.165C311.605 176.71 308.761 177.219 308.761 177.219C308.761 177.219 312.492 181.121 313.558 180.273C314.625 179.425 314.98 177.729 315.691 176.88C316.402 176.031 325.287 168.735 326.354 163.476C327.42 158.217 319.423 145.493 313.204 144.305C306.985 143.116 295.435 145.831 295.435 145.831Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M284.848 167.78L286.295 173.358C286.449 173.952 286.973 174.387 287.612 174.442C289.241 174.581 292.205 174.728 292.589 173.995C293.123 172.977 292.412 166.361 291.523 165.343C290.433 164.094 287.949 165.089 286.75 165.64C286.419 165.791 285.818 166.183 285.342 166.506C284.919 166.793 284.724 167.297 284.848 167.78Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M292.768 168.056L307.518 166.699L292.839 169.584L292.768 168.056Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M307.873 177.218C307.873 177.218 310.006 183.157 308.584 184.853C307.162 186.549 302.542 189.264 302.542 189.264",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M307.873 177.218C307.873 177.218 310.006 183.157 308.584 184.853C307.162 186.549 302.542 189.264 302.542 189.264",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M319.78 184.344C319.78 184.344 297.034 204.194 297.567 204.704C298.101 205.212 302.156 211.109 302.156 211.109C302.156 211.109 308.053 202.735 312.199 198.325C316.622 193.619 324.045 187.567 324.045 187.567L319.78 184.344Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M266.29 237.618C266.29 237.618 259.892 237.618 258.649 238.976C257.405 240.333 260.782 241.69 262.026 241.86C263.27 242.03 266.647 241.351 266.647 241.351L266.29 237.618Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M269.134 236.091C269.134 236.091 266.291 235.073 265.58 237.278C264.87 239.484 266.647 246.101 267.713 246.271C268.779 246.441 269.313 245.762 269.313 243.726C269.311 241.689 269.134 236.091 269.134 236.091Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M274.11 235.751C274.11 235.751 270.378 233.715 268.956 235.242C267.534 236.769 269.134 245.761 269.134 245.761C270.2 246.27 271.977 240.332 273.577 238.466C275.176 236.6 275.532 235.922 275.532 235.922L274.11 235.751Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M297.211 235.921C297.211 235.921 287.971 244.065 286.372 244.065C284.772 244.065 278.197 236.77 276.598 235.921C274.999 235.073 272.867 239.823 272.333 241.35C271.8 242.876 271.622 246.44 271.622 246.44C271.622 246.44 272.511 247.458 273.399 246.27C274.288 245.082 276.42 240.671 276.42 240.671L277.487 242.029",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M297.211 235.921C297.211 235.921 287.971 244.065 286.372 244.065C284.772 244.065 278.197 236.77 276.598 235.921C274.999 235.073 272.867 239.823 272.333 241.35C271.8 242.876 271.622 246.44 271.622 246.44C271.622 246.44 272.511 247.458 273.399 246.27C274.288 245.082 276.42 240.671 276.42 240.671L277.487 242.029",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M282.461 241.689C282.461 241.689 276.952 242.537 276.064 244.064C275.175 245.591 274.997 245.76 276.952 245.93C278.907 246.1 283.528 246.609 284.238 245.76C284.949 244.912 283.173 241.859 282.461 241.689Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M250.475 252.039L228.439 206.061L241.944 206.739L260.96 249.833L250.475 252.039Z",
    fill: "#F0C66C",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M259.715 246.609L249.941 250.682H303.431L296.145 246.271L259.715 246.609Z",
    fill: "#F0C66C",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M317.648 203.176C317.648 203.176 310.895 204.364 309.829 210.133C308.763 215.901 311.784 237.957 311.784 238.466C311.784 238.975 311.784 241.52 311.784 242.538C311.784 243.556 316.049 243.217 321.024 245.423C326 247.628 329.021 251.191 329.021 248.477C329.021 245.762 328.31 213.187 328.31 213.187",
    fill: "#E69724"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M317.648 203.176C317.648 203.176 310.895 204.364 309.829 210.133C308.763 215.901 311.784 237.957 311.784 238.466C311.784 238.975 311.784 241.52 311.784 242.538C311.784 243.556 316.049 243.217 321.024 245.423C326 247.628 329.021 251.191 329.021 248.477C329.021 245.762 328.31 213.187 328.31 213.187",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M328.665 226.25L331.508 216.919",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M308.407 239.823L309.295 247.119C309.295 247.119 328.665 257.978 329.198 257.638C329.731 257.298 330.264 256.28 330.264 254.584C330.264 252.887 333.107 244.065 329.732 242.029C326.355 239.993 313.916 239.653 313.916 239.653C313.916 239.653 310.362 238.975 308.407 239.823Z",
    fill: "#543C7D",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M310.717 246.779C310.717 246.779 292.414 253.057 280.508 253.736C268.602 254.414 267.18 253.736 267.18 253.736C267.18 253.736 266.113 249.663 264.336 248.645C262.56 247.627 256.872 248.476 255.806 247.797C254.74 247.119 254.74 244.913 254.029 244.235C253.319 243.556 250.12 243.895 250.12 243.895C250.12 243.895 248.521 244.743 248.521 245.931C248.521 247.119 247.455 254.754 248.877 255.432C250.299 256.11 268.779 259.504 275.711 259.504C282.641 259.504 303.077 261.37 313.562 259.844C324.047 258.316 327.957 257.129 327.601 254.415C327.243 251.699 314.093 246.101 310.717 246.779Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M249.231 244.913L249.586 253.905",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M252.074 244.065L252.607 252.887",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M255.806 247.797C255.806 247.797 255.096 249.833 256.34 250.681C257.584 251.53 262.382 252.208 262.382 252.208",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M255.806 247.797C255.806 247.797 255.096 249.833 256.34 250.681C257.584 251.53 262.382 252.208 262.382 252.208",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M308.763 222.857H300.232V236.26H308.763V222.857Z",
    fill: "white",
    stroke: "#543C7D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImage);
export default __webpack_public_path__ + "static/media/about-image.d1ff309f196a113d6c26a7fda11b0ffa.svg";
export { ForwardRef as ReactComponent };